module.exports = __webpack_public_path__ + "img/ife-aa_header_xs.2f523ade.png";